<template>
    <div>
        <form action="" @submit.prevent="send">
		<div class="level">
			<div class="level-left">
				<div class="level-item">
					<h1 class="title">Mensajes Broadcasts</h1>
				</div>
			</div>
			<div class="level-right">
				<div class="level-item">
					<button class="button is-primary">
                        <span class="icon"><font-awesome-icon icon="paper-plane"/></span>
                        <span>Enviar Mensaje</span>
                    </button>
				</div>
			</div>
		</div>

            <div class="field">
                <label for="" class="label">Id</label>
                <div class="control">
                    <input class="input" type="text" placeholder="1,2,3,texto random" name="title" v-model="mensaje.id">
                </div>
                <p class="help">Titulo de la notificacion</p>
            </div>
            <div class="field">
                <label for="" class="label">Title</label>
                <div class="control">
                    <input class="input" type="text" placeholder="Quinielazo" name="title" v-model="mensaje.title" required>
                </div>
                <p class="help">Titulo de la notificacion</p>
            </div>
            <div class="field">
                <label for="" class="label">Body</label>
                <div class="control">
                    <input class="input" type="text" placeholder="Body" name="title" v-model="mensaje.body" required>
                </div>
                <p class="help">Cuerpo de la notificacion</p>
            </div>
            <div class="field">
                <label for="" class="label">Icon</label>
                <div class="control">
                    <input class="input" type="text" placeholder="/img/icons/msapplication-icon-144x144.png" name="icon" v-model="mensaje.icon">
                </div>
                <p class="help">Icono de la notificacion</p>
            </div>
            <div class="field">
                <label for="" class="label">Badge</label>
                <div class="control">
                    <input class="input" type="text" placeholder="/img/icons/quinibadge.png" name="badge" v-model="mensaje.badge">
                </div>
                <p class="help">Badge de la notificacion</p>
            </div>

            <div class="field">
                <label for="" class="label">Tag</label>
                <div class="control">
                    <input class="input" type="text" placeholder="quinielas-publicas" name="tag" v-model="mensaje.tag">
                </div>
                <p class="help">Tag de la notificacion, puedes sobresscribir otras con un mismo tag</p>
            </div>

            <div class="field">
                <label for="" class="label">URL</label>
                <div class="control">
                    <input class="input" type="text" placeholder="https://quinielazo.com/ver-quiniela/5555" name="url" v-model="mensaje.url">
                </div>
                <p class="help">URL de la notificacion al hacer click</p>
            </div>

            <div class="field">
                <label for="" class="label">Recipientes</label>
                <div class="control">
                    <input class="input" type="text" placeholder="1,2,3,4,5...." name="badge" v-model="usuarios">
                </div>
                <p class="help">Ids de usuarios que reciben la notificacion</p>
            </div>
        </form>
	</div>
</template>

<script>
    export default {
        name: "Broadcasts",
        data() {
            return {
                mensaje: {},
                usuarios: ""
            }
        },
        computed: {
            
        },
        methods: {
            send(){
                if(confirm('Estas seguro que quieres enviar el mensaje?')){
                    if (this.usuarios != "") {
                        if (this.usuarios.length > 1 && this.usuarios.indexOf(",")) {
                            this.mensaje.usuarios = this.usuarios.split(',')
                        }else{
                            this.mensaje.usuarios = [this.usuarios]
                        }
                    }
                    this.$store.dispatch('notification/webPush', this.mensaje)
                    .then(() => this.clearForm())
                }
            },
            clearForm(){
                this.mensaje = {},
                this.usuarios = ""
            }
        },
    }
</script>

<style lang="css" scoped>

</style>